import {
  Unavailability,
  Identifiable,
  UnavailabilitiesFilter,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { linkResources } from "../utils/linkResources";
import { LinkedResource } from "../linkers/types";

type Response = {
  _embedded: {
    unavailabilities: LinkedResource<Identifiable<Unavailability>>[];
  };
};
function getUnavailabilities(httpClient: HttpClient) {
  return (filter: UnavailabilitiesFilter) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/unavailabilities/search/rsql?query=startDate>=${filter.startDate};startDate<=${filter.endDate},endDate<=${filter.endDate};endDate>=${filter.startDate}&size=99999`,
        method: HttpMethods.GET,
      })
      .then((response) =>
        response._embedded ? response._embedded.unavailabilities : [],
      )
      .then((unavailabilities) =>
        Promise.all(unavailabilities.map((u) => linkResources(httpClient, u))),
      );
}

export { getUnavailabilities };
